
import React, { useState, useEffect, useRef } from 'react';
import { useAuth } from '../context/AuthContext';
import { useData } from '../context/DataContext';

const PendingValidationScreen: React.FC = () => {
  const { logout, currentUser, checkRestaurantStatus, refreshProfile } = useAuth();
  const { refreshRestaurants } = useData();
  const [isChecking, setIsChecking] = useState(false);
  const intervalRef = useRef<number | null>(null);

  const handleRefresh = async () => {
    setIsChecking(true);
    try {
      console.log("⚡ Forçage vérification statut...");
      // On utilise la vérification légère et ciblée
      await checkRestaurantStatus();
      // On recharge aussi les données globales au cas où
      await refreshRestaurants();
    } finally {
      setTimeout(() => {
        setIsChecking(false);
      }, 800);
    }
  };

  const handleHardReload = () => {
    // Solution de dernier recours : recharger la page pour vider les états React
    window.location.reload();
  };

  useEffect(() => {
    // Polling removed: We now rely exclusively on the global `onSnapshot` listener in AuthContext
    // to detect status changes in real-time without burning Firebase Reads.
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, []);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 p-6 text-center">
      <div className="w-24 h-24 bg-yellow-100 rounded-full flex items-center justify-center mb-6 relative">
        <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 text-yellow-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        {isChecking && (
          <div className="absolute inset-0 rounded-full border-4 border-yellow-400 border-t-transparent animate-spin"></div>
        )}
      </div>

      <h1 className="text-3xl font-black text-gray-900 mb-2 uppercase italic tracking-tighter">Validation en cours</h1>
      <p className="text-gray-600 max-w-md mb-8">
        Bonjour <span className="font-bold">{currentUser?.name}</span>,<br />
        Votre demande d'inscription est en cours de traitement par nos administrateurs.
      </p>

      {/* Encadré statut supprimé ici comme demandé */}

      <div className="space-y-3 w-full max-w-xs">
        <button
          onClick={handleRefresh}
          disabled={isChecking}
          className="w-full px-6 py-3 bg-green-600 text-white font-bold rounded-full hover:bg-green-700 transition-colors shadow-lg flex items-center justify-center gap-2 disabled:opacity-70"
        >
          {isChecking ? "Vérification..." : "Vérifier maintenant"}
        </button>

        <button
          onClick={handleHardReload}
          className="w-full px-6 py-3 bg-blue-50 text-blue-700 font-bold rounded-full hover:bg-blue-100 transition-colors border border-blue-100"
        >
          Actualiser l'application
        </button>

        <button
          onClick={logout}
          className="w-full px-6 py-3 text-gray-500 font-medium hover:text-gray-700 transition-colors text-sm underline"
        >
          Se déconnecter
        </button>
      </div>

      <p className="mt-8 text-xs text-gray-300">ID: {currentUser?.uid}</p>
    </div>
  );
};

export default PendingValidationScreen;
